import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { AuthenticationService } from '@lib/core';
import { CredentialsService } from '@lib/core/authentication/credentials.service';
import { ToastService } from '@lib/shared/services/toast.service';
import { getLoginErrorMessage } from '../auth-error-messages';
import * as Sentry from '@sentry/angular';

@Component({
    selector: 'app-login-form',
    templateUrl: './login-form.component.html',
    standalone: false
})
@Sentry.TraceClass({ name: 'LoginFormComponent' })
export class LoginFormComponent {
  public loginForm: UntypedFormGroup;
  public isIos: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private authenticationService: AuthenticationService,
    private toastService: ToastService,
    public credentialsService: CredentialsService,
    private platform: Platform,
  ) {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
    this.isIos = this.platform.is('ios');
  }

  async login() {
    console.info('[LoginForm] Login attempt started');
    this.authenticationService.nextLoading(true);
    try {
      await this.authenticationService.login(this.loginForm.value);
      console.info('[LoginForm] Firebase authentication succeeded');
    } catch (error: any) {
      console.error(error);
      this.authenticationService.nextLoading(false);
      this.toastService.showDissmissableErrorToast(getLoginErrorMessage(error?.code));
      return;
    }
    this.loginForm.markAsPristine();
    this.authenticationService.nextLoading(false);

    const targetRoute = this.route.snapshot.queryParams.redirect || '/tabs/home';
    try {
      const navigationSucceeded = await this.router.navigate([targetRoute], { replaceUrl: true });
      console.info('[LoginForm] Post-login navigation result', { targetRoute, navigationSucceeded });
      if (!navigationSucceeded) {
        this.toastService.showDissmissableErrorToast(
          'Signed in, but we could not open your account. Please try again.',
        );
      }
    } catch (error) {
      console.error('[LoginForm] Post-login navigation failed', error);
      this.toastService.showDissmissableErrorToast(
        'Signed in, but we could not finish loading your account. Please try again.',
      );
    }
  }

  public showResetPassword() {
    this.authenticationService.nextResetPassword(true);
  }
}
